import {
  CHATBOT_MESSAGE_SENT_SOURCES,
  type ChatbotMessageSentSource,
} from '../types';

// Validates untrusted input (the `?source=` URL param and route state) at
// runtime against the genuine entry points. `'unknown'` is deliberately not a
// valid value here — it's only ever assigned as a fallback, never received.
export const isChatbotMessageSentSource = (
  value: string | null | undefined,
): value is ChatbotMessageSentSource =>
  (CHATBOT_MESSAGE_SENT_SOURCES as readonly string[]).includes(value ?? '');
